import { Box, Button, Typography } from "@mui/joy";
import Add from '@mui/icons-material/Add';
import React, { useRef, useState } from "react";
import { Dialog } from 'primereact/dialog';
import GenericTableView from "../../components/GenericTableView";
import { FilterMatchMode } from "primereact/api";
import { GenericTableColumTypes, GenericTableFilterTypes } from "../../enum/TableView";
import { MenuItem } from "primereact/menuitem";
import { GenericTableColumns } from "../../models/GenericTableViewModel";
import { removeClient } from "../../service/clientService";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";
import { Toast } from 'primereact/toast';
import { RouteComponentProps } from "../../models/RouteComponent";
import PPEAdd from "./ppe-Add";
import { removePPE } from "../../service/ppeService";
import { v4 as uuid } from 'uuid';
import PPEImport from "./ppe-Import";

export default function PPEView(props: RouteComponentProps) {

  const [selectedType, setTypes] = useState({} as any);
  const [visible, setVisible] = useState(false);
  const [reload, setReload] = useState(false);
  const [importVisible, setImportVisible] = useState(false);
  const toast = useRef(null as any);
  const dialog = useRef(null as any);

  const clientId = props.session.client_id;

  const baseFilter = {
    'type': { value: '', matchMode: FilterMatchMode.CONTAINS }
  }

  const deleteButton = (row: any) => {
    console.log("deleteButton row == ", selectedType);
    removeClient(selectedType.id);
  }

  const addButton = (row: any) => {
    console.log("addButton row == ", row)
    setTypes(null);
    setVisible(true);
  }

  const itemSelected = (row: any) => {
    console.log("itemSelected row == ", row)
    setTypes(row.value);
    editConfirm(row);
  }

  const contextItemSelected = (row: any) => {
    console.log("contextItemSelected row == ", row)
    setTypes(row.value);
  }

  const acceptFunc = async () => {
    props.setGlobalLoader(true);
    const industry = await removePPE(selectedType.id);
    props.setGlobalLoader(false);
    setReload(!reload);
    toast.current.show({ severity: 'success', summary: 'PPE Deleted Successfully', life: 3000 });
  }

  const editConfirm = (row: any) => {
    setVisible(true);
  }

  const deleteConfirm = (row: any) => {
    confirmDialog({
      message: 'Are you sure you want to proceed?',
      header: 'Confirmation',
      icon: 'pi pi-exclamation-triangle',
      accept: () => acceptFunc()
    });
  }


  const contextItems = () => {
    let objArray = [
      { label: 'Edit', icon: 'pi pi-fw pi-pencil', command: editConfirm },
    ];
    objArray.push({ label: 'Delete', icon: 'pi pi-fw pi-trash', command: deleteConfirm });
    return objArray;
  }

  const importButton = (row: any) => {
    console.log("importButton row == ", row)
    setImportVisible(true);
  }

  const columns: GenericTableColumns[] = [
    {
      field: "photo",
      header: "Image",
      type: GenericTableColumTypes.Image,
      visible: true,
      sort: false,
      filter: false,
      filterOption: {
        type: GenericTableFilterTypes.Text,
        options: [
          {
            label: "",
            value: ""
          }
        ]
      }
    },
    {
      field: 'name',
      header: 'Name',
      type: GenericTableColumTypes.Text,
      visible: true,
      sort: true,
      filter: false,
      filterOption: {
        type: GenericTableFilterTypes.Text,
        options: [{
          label: '',
          value: ''
        }]
      }
    },
    {
      field: 'hazard_list',
      header: 'Hazard',
      type: GenericTableColumTypes.Text,
      visible: true,
      sort: true,
      filter: false,
      filterOption: {
        type: GenericTableFilterTypes.Text,
        options: [{
          label: '',
          value: ''
        }]
      }
    },
    {
      field: 'industry_list',
      header: 'Industry',
      type: GenericTableColumTypes.Text,
      visible: !clientId,
      sort: true,
      filter: false,
      filterOption: {
        type: GenericTableFilterTypes.Text,
        options: [{
          label: '',
          value: ''
        }]
      }
    },
     {
      field: 'required',
      header: 'Mandatory',
      type: GenericTableColumTypes.Boolean,
      visible: true,
      sort: true,
      filter: false,
      filterOption: {
        type: GenericTableFilterTypes.Boolean,
        options: [{
          label: '',
          value: ''
        }]
      }
    }
  ];


  return (
    <React.Fragment>
      <Box
        sx={{
          display: 'flex',
          mb: 1,
          gap: 1,
          flexDirection: { xs: 'column', sm: 'row' },
          alignItems: { xs: 'start', sm: 'center' },
          flexWrap: 'wrap',
          justifyContent: 'space-between',
        }}
      >
        <Typography level="h2" component="h1">
          PPE
        </Typography>


        {/* <Button
            color="primary"
            startDecorator={<Add />}
            size="sm"
            onClick={() => setVisible(true)}
          >Add</Button> */}
      </Box>

      <GenericTableView reload={reload} baseFilters={baseFilter} url="ppe" columns={columns} contextItems={contextItems} importButton={clientId ? importButton : undefined} addButton={!clientId ? addButton : undefined} itemSelect={itemSelected} contextItemSelected={contextItemSelected} />

      <Dialog ref={dialog} header={selectedType?.id ? !!clientId? 'View PPE': 'Update PPE' : 'Add PPE'} visible={visible} style={{ width: '50vw' }} onHide={() => setVisible(false)}>
        <PPEAdd
          setGlobalLoading={props.setGlobalLoader}
          setReload={setReload}
          reload={reload}
          id={selectedType?.id}
          details={selectedType}
          setVisible={setVisible}
          toast={toast}
          uuid={uuid()}
          clientId={clientId}
        />
      </Dialog>

      <Dialog header={"Import PPE"} visible={importVisible} style={{ width: '50vw' }} onHide={() => setImportVisible(false)}>
        <PPEImport setGlobalLoading={props.setGlobalLoader} setReload={setReload} reload={reload} uuid={uuid()} setVisible={setImportVisible} toast={toast} session={props.session} />
      </Dialog>

      <ConfirmDialog />

      <Toast ref={toast} />


    </React.Fragment>
  );
}